// extracted by mini-css-extract-plugin
export default {"datePicker":"styles__datePicker--XTMNy"};